import { AnyAction, createAction, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { jwtDecode as jwt_decode, JwtPayload } from 'jwt-decode';
import { getAccessTokenAsync } from '@buy-viasat/utils';
import { createSlice } from '../utils';
import { RESET_AUTH_ACTION } from '../types';
import { appActions } from '../app';
import { Country } from '@buy-viasat/types/build/bv';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { USE_NEW_API } from '../../../../packages/client/src/shared/utils/dataFetchingHooks/constants';

export type AuthState = {
  accessToken: string;
  flowId: string;
  resetToken: boolean;
};

export const initialAuthState = {
  accessToken: '',
  flowId: '',
  resetToken: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initialAuthState,
  reducers: {
    setAccessToken(state: AuthState, action: PayloadAction<string>): void {
      state.accessToken = action.payload;
    },
    setFlowId(state: AuthState, action: PayloadAction<string>): void {
      state.flowId = action.payload;
    },
    setResetToken(state: AuthState, action: PayloadAction<boolean>): void {
      state.resetToken = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetState, (): AuthState => initialAuthState);
  },
});

const resetState = createAction(RESET_AUTH_ACTION.type);

export const { actions: authActions, reducer: authReducer, name: authKey } = authSlice;

type RequestAccessTokenInput = { env: string; authUrl: string; expiredSession?: boolean };

interface JwtPayloadWithFlowId extends JwtPayload {
  flowId: string;
  country: Country;
  customerType: string;
  env: string;
  exp: number;
  iat: number;
  language: string;
}

export const requestAccessToken = createAsyncThunk(
  'requestAccessToken',
  async (input: RequestAccessTokenInput, thunkAPI) => {
    try {
      const { token } = await getAccessTokenAsync(input.env, input.authUrl);
      const decoded = jwt_decode<JwtPayloadWithFlowId>(token);
      const { flowId } = decoded;

      console.log('Buy Viasat flowId: ' + flowId);
      thunkAPI.dispatch(authActions.setAccessToken(token));
      thunkAPI.dispatch(authActions.setFlowId(flowId));
      if (!USE_NEW_API) {
        thunkAPI.dispatch(appActions.retrieveFeatureFlags());
      }
      thunkAPI.dispatch(authActions.setResetToken(input.expiredSession || false));
    } catch (error) {
      thunkAPI.dispatch(appActions.loadFeatureFlags({}));
      thunkAPI.dispatch(appActions.setFeatureFlag({ maintenanceMode: true }));
      return;
    }
  },
) as unknown as (input: RequestAccessTokenInput) => AnyAction;
